import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-chips',
  templateUrl: './formly-chips.component.html',
  styleUrls: [],
})
export class FormlyChipsComponent extends FieldType {}
